import { FaPhoneAlt } from "react-icons/fa";
import agentImg from "../assets/agent.png";

const SupportCard = () => {
  return (
    <div className="
      w-full 
      max-w-md 
      mx-auto 
      p-8 
      bg-gradient-to-br from-white via-orange-50 to-white 
      border border-orange-300 
      rounded-3xl 
      shadow-2xl 
      text-center 
      transition-all 
      duration-300 
      hover:shadow-3xl 
      hover:-translate-y-1
    ">
      
      {/* Agent Image */}
      <div className="flex justify-center mb-6">
        <img
          src={agentImg}
          alt="Agent"
          className="w-32 h-32 rounded-full border-4 border-orange-500 shadow-xl object-cover"
        />
      </div>

      {/* Title */}
      <h2 className="text-2xl font-extrabold text-gray-900 mb-3">
        Need Help Finding Deals?
      </h2>

      <p className="text-base text-gray-600 leading-relaxed mb-4 px-3">
        Our expert travel agents are ready to secure unbeatable flight deals 
        and guide you with personalized assistance.
      </p>

      {/* Call Now */}
      <p className="text-base font-semibold text-gray-700 mt-1 mb-4">
        Call Now – Talk to a Live Agent
      </p>

      <a
        href="tel:+18887112909"
        className="
          inline-flex 
          items-center 
          justify-center 
          w-full 
          gap-3 
          bg-gradient-to-r from-orange-500 to-red-500 
          text-white 
          font-bold 
          py-3.5 
          rounded-xl 
          shadow-xl 
          hover:shadow-2xl 
          hover:scale-[1.03] 
          transition-all
          text-lg
        "
      >
        <FaPhoneAlt className="text-xl" /> +1 888-711-2909
      </a>

      {/* Footer */}
      <p className="text-sm text-gray-500 mt-5">
        24/7 Expert Assistance • Fast Responses • Best Prices Guaranteed
      </p>
    </div>
  );
};

export default SupportCard;
